// extracted by mini-css-extract-plugin
export default {"placeholder-wrapper":"styles_placeholder-wrapper__mon9-","placeholder-title":"styles_placeholder-title__iMQht"};